export default __webpack_public_path__ + "static/media/arrow-left.dc6e97fd.svg";